<template>
  <v-dialog
      v-model="dialog"
  >
    <v-card elevation="0">
      <v-col class="text-right px-4">
        <v-btn icon @click="dialog=false">
          <v-icon large color="primary">close</v-icon>
        </v-btn>
      </v-col>
      <v-container v-if="dialog">
        <v-form ref="form">
          <v-row justify="space-around">
            <v-col cols="12" md="5">
              <v-text-field
                outlined
                v-model="update.description"
                :label="$t('common:description')"
                :rules="[
                  ruleRequired($t('utils:rules.required')),
                ]"
              />

              <v-text-field
                outlined
                v-model="update.version"
                :label="$t('settings/settings:update.version')"
              />

              <v-select
                outlined
                :items="osList"
                item-text="name"
                item-value="id"
                v-model="update.os"
                :label="$t('settings/settings:update.os')"
              />

              <v-select
                outlined
                :items="channels"
                item-text="name"
                item-value="id"
                v-model="update.channel"
                :label="$t('settings/settings:update.channel')"
              />

              <v-checkbox
                v-model="update.active"
                :label="$t('common:active')" />

              <v-file-input
                v-if="!edit"
                ref="uploadedFile"
                :label="$t('components:common.filename')"
                show-size
                v-model="file"
                :rules="[
                  ruleRequired($t('utils:rules.required')),
                ]"
              />

              <v-btn
                v-if="edit"
                outlined color="primary"
                @click="downloadFile"
                >
                <v-icon>file_download</v-icon>
                <span class="d-none d-sm-block">{{ $t('buttons:download') }}</span>
              </v-btn>

            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-card
                elevation="0"
                flat
                tile
                class="pl-3 pt-3 pb-md-3"
              >
                <TwoButtonDialog
                    ref="saveButton"
                    :btn-text="$t('buttons:save')"
                    color="primary"
                    :hideOverlay="true"
                    :dialog-title="$t('dialog:save-btn-title', {name : $t('settings/settings:update.update') })"
                    :dialog-text="$t('dialog:save-btn-dialog', {name : $t('settings/settings:update.update') })"
                    :button1-text="$t('buttons:save')"
                    :button2-text="$t('buttons:cancel')"
                    @clickedButton1="updateForm()"
                    @clickedButton2="$refs.saveButton.showDialog = false"
                />
                <DirtyConfirmButtonDialog
                    ref="dirtyDialog"
                    :btn-text="$t('buttons:back')"
                    color="grey"
                    :hideOverlay="true"
                    :dialog-title="$t('dialog:save-btn-title')"
                    :dialog-text="$t('dialog:save-btn-dialog')"
                    :button1-text="$t('dialog:dirty-save-btn-1-text')"
                    :button2-text="$t('dialog:dirty-save-btn-2-text')"
                    @clickedButton="dialog=false"
                />
              </v-card>
            </v-col>
          </v-row>
        </v-form>
      </v-container>
    </v-card>
  </v-dialog>
</template>

<script>

import DirtyConfirmButtonDialog from '@/modules/core/components/TwoButtonDialog/DirtyConfirmButtonDialog';
import TwoButtonDialog from '@/modules/core/components/TwoButtonDialog/TwoButtonDialog';
import UpdateService from '@/modules/settings/services/update-service';
import {ruleRequired} from '@/modules/core/services/rules';
import Utils from '@/modules/core/services/utils';

export default {
  name: "SettingForm",
  components: {
    DirtyConfirmButtonDialog,
    TwoButtonDialog
  },
  data() {
    return {
      update: {},
      dialog: false,
      edit: false,
      file: null,
      osList: [
        {id: 'windows', name: 'Windows'},
        {id: 'linux', name: 'Linux'}
      ],
      channels: [
        {
          id: "release",
          name: this.$t('settings/settings:update.selects.release')
        },
        {
          id: "beta",
          name: this.$t('settings/settings:update.selects.beta')
        }
      ],

    }
  },
  methods: {
    ruleRequired,
    updateForm() {
      if (!this.$refs.form.validate()) {
        this.$refs.saveButton.showDialog = false;
        window.scrollTo(0, 0);
        return;
      }

      this.dialog = false;
      UpdateService.saveUpdate(
          this.update,
          this.file,
          () => {
            if (!this.edit) {
              Utils.showSuccessSnackbar(this.$t('snackbar:add-success', {name: this.$t('settings/settings:update.update')}));
            } else {
              Utils.showSuccessSnackbar(this.$t('snackbar:edit-success', {name: this.$t('settings/settings:update.update')}));
            }

            this.$emit('updateTable');
          },
          () => {
            if (!this.edit) {
              Utils.showFailureSnackbar(this.$t('snackbar:add-failure', {name: this.$t('settings/settings:update.update')}));
            } else {
              Utils.showFailureSnackbar(this.$t('snackbar:edit-failure', {name: this.$t('settings/settings:update.update')}));
            }
          }
      )
    },
    downloadFile() {
      UpdateService.getFile(
          this.update.id,
          (file) => {
            const link = document.createElement('a');
            link.href = URL.createObjectURL(file);
            link.download = this.update.id;
            link.click();
            URL.revokeObjectURL(link.href);
          },
          () => {
            Utils.showFailureSnackbar(this.$t('snackbar:load-failure', {name: this.$t('components:documentation-upload-form.file')}));
          }
      )
    },
    initialization(item) {
      this.update = {};
      this.edit = false;
      this.file = null;

      if (typeof item !== 'undefined' && typeof item.id !== 'undefined') {
        this.update = item;
        this.edit = true;
      }

      this.dialog = true;
    }
  }
}
</script>
